import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { setEvent } from "@/store/event/eventSlice";
import { useEvent } from "./useEvent";

type BaseEvent<P = unknown> = {
  type: string;
  payload: P;
};

export function useDispatchBaseEvent<T extends BaseEvent>(eventType: T["type"]) {
  const dispatch = useDispatch();
  const dispatchEvent = useEvent<T>(eventType);

  return useCallback(
    (payload: T["payload"]) => {
      // console.log("useDispatchBaseEvent payload", eventType);
      dispatch(
        setEvent({
          type: eventType,
          payload,
        })
      );
      dispatchEvent({ payload } as Omit<T, "type">);
    },
    [dispatch, dispatchEvent, eventType]
  );
}

export function useSubscribeToBaseEvent<T extends BaseEvent>(
  eventType: T["type"],
  handler: (payload: T["payload"]) => void
) {
  // console.log("useSubscribeToBaseEvent", eventType);
  useEvent<T>(eventType, ({ payload }) => {
    handler(payload);
  });
}
